import { APP_ACTION_TYPES } from './appActions';
import { initialState } from './appState';

export const appConfigReducer = (state, action) => {
    switch (action.type) {
        case APP_ACTION_TYPES.SET_AB_TEST_VARIANT:
            return { ...state, abTestVariant: action.payload };

        case APP_ACTION_TYPES.SET_HIDE_DEV_MODE:
            return { ...state, hideDevMode: action.payload };

        case APP_ACTION_TYPES.SET_APP_DATA:
            return { ...state, appData: action.payload };

        case APP_ACTION_TYPES.SET_QUIZ_DATA:
            return { ...state, quizData: action.payload };

        case APP_ACTION_TYPES.SET_PAGE_CONTENT:
            return { ...state, remotePageContent: action.payload };

        case APP_ACTION_TYPES.SET_UPSELLS_DATA:
            return { ...state, upsellsPageData: action.payload };

        case APP_ACTION_TYPES.SET_FEEDBACK_DATA:
            return { ...state, feedbackData: action.payload };

        case APP_ACTION_TYPES.SET_COMPONENTS_DATA:
            return { ...state, componentsData: action.payload };

        case APP_ACTION_TYPES.SET_NEW_PAGE_REVIEWS:
            return { ...state, newPageReviews: action.payload };

        case APP_ACTION_TYPES.SET_VIDEO_REVIEWS:
            return { ...state, newPageVideoReviews: action.payload };

        case APP_ACTION_TYPES.SET_PAYMENT_BUTTONS:
            return { ...state, paymentButtons: action.payload };

        case APP_ACTION_TYPES.SET_OPTION_TEXT_DATA:
            return { ...state, optionTextData: action.payload };

        case APP_ACTION_TYPES.SET_API_GEO_URL:
            return { ...state, apiGeoUrl: action.payload };

        case APP_ACTION_TYPES.SET_REDIRECT_URL:
            return { ...state, redirectUrl: action.payload };

        case APP_ACTION_TYPES.SET_EMAIL_PROVIDERS:
            return { ...state, emailProviders: action.payload };

        case APP_ACTION_TYPES.SET_AB_TEST_CAMPAIGN_NAME:
            return { ...state, abTestCampaignName: action.payload };

        case APP_ACTION_TYPES.SET_AB_TEST_START_CAMPAIGN_DATE:
            return { ...state, abTestStartCampaignDate: action.payload };

        case APP_ACTION_TYPES.SET_EMAILS_TO_DISABLE_ANALYTICS:
            return { ...state, emailsToDisableAnalyticsEvent: action.payload };

        case APP_ACTION_TYPES.SET_QA_TIMER_TIME:
            return { ...state, QAtimerTime: action.payload };

        case APP_ACTION_TYPES.SET_IS_CONFIG_READY:
            return { ...state, isConfigReady: action.payload };

        case APP_ACTION_TYPES.SET_FLOW_USE_AB_TEST:
            return { ...state, flowUseABtest: action.payload };

        case APP_ACTION_TYPES.SET_ENABLE_UPSELLS:
            return { ...state, enableUpsells: action.payload };

        case APP_ACTION_TYPES.SET_PATH_PREFIX:
            return { ...state, pathPrefix: action.payload };

        case APP_ACTION_TYPES.SET_MULTIPLE_CONFIG:
            return { ...state, ...action.payload };

        case APP_ACTION_TYPES.RESET_STATE:
            return { ...initialState };

        case APP_ACTION_TYPES.SET_PEOPLE_WAITLIST_DATA:
            return { ...state, peopleOnWaitlist: action.payload };

        case APP_ACTION_TYPES.SET_FLOW_DATA:
            return { ...state, flowData: action.payload };

        case APP_ACTION_TYPES.SET_ANALYTICS_DATA:
            return { ...state, analyticsData: action.payload };

        case APP_ACTION_TYPES.SET_DISCLAIMER_TEXT:
            return { ...state, disclaimerText: action.payload };
        case APP_ACTION_TYPES.SET_DISCLAIMER_ONE_TIME_TEXT:
            return { ...state, disclaimerOneTimeText: action.payload };
        default:
            return state;
    }
};